import { parse } from './parse';
export const mask = options => {
  const maskOptions = parse(options);
  let prevSelection;
  return {
    setPlaceholder(input) {
      if (input.value == '') {
        setInput(input, maskOptions.maskPlaceholder, 0);
      }
    },

    clearPlaceholder(input) {
      if (input.value == maskOptions.maskPlaceholder) {
        setInput(input, '', 0);
        prevSelection = getInputSelection(input);
        input.dispatchEvent(new Event('input', {
          bubbles: true
        }));
      }
    },

    updateSelection(input) {
      prevSelection = getInputSelection(input);
    },

    processChange(input) {
      if (!prevSelection) {
        return;
      }

      const curSelection = getInputSelection(input);
      const insObj = getInsertInfo(prevSelection, curSelection);
      let cursorPosition = curSelection.start;
      let value = prevSelection.value;

      if (insObj.remove) {
        value = removeSubString(value, insObj.remove);
      }

      if (insObj.add) {
        const [newValue, curPos] = addSubString(value, insObj.add);
        value = newValue;
        cursorPosition = curPos;
      }

      setInput(input, value, cursorPosition);
    }

  };

  function removeSubString(value, insObj) {
    const {
      maskPlaceholder
    } = maskOptions;
    const startStr = value.slice(0, insObj.posStart);
    const middleStr = maskPlaceholder.slice(insObj.posStart, insObj.posEnd);
    const endStr = value.slice(insObj.posEnd);
    return startStr + middleStr + endStr;
  }

  function addSubString(value, insObj) {
    const {
      maskPlaceholder
    } = maskOptions;
    let pos = insObj.posStart;

    if (!insObj.value) {
      return [value, pos];
    }

    let valueArray = insObj.value.split('');
    let result = '';

    for (let i = 0; i < valueArray.length && pos < maskPlaceholder.length; i++) {
      let char = valueArray[i];
      const isAllowed = isCharacterAllowedAtPosition(char, pos);
      const isEditable = isPositionEditable(pos);

      if (isAllowed) {
        result = result + char;
        pos++;
      } else if (!isAllowed && !isEditable) {
        result = result + (maskPlaceholder === null || maskPlaceholder === void 0 ? void 0 : maskPlaceholder.slice(pos, pos + 1));
        pos++;
        i--;
      }
    }

    const startStr = value.slice(0, insObj.posStart);
    const endStr = value.slice(insObj.posStart + result.length);
    value = startStr + result + endStr;
    return [value, pos];
  }

  function isCharacterAllowedAtPosition(character, position) {
    const {
      maskPlaceholder
    } = maskOptions;

    if (isCharacterFillingPosition(character, position)) {
      return true;
    }

    return maskPlaceholder[position] === character;
  }

  function isCharacterFillingPosition(character, position) {
    const {
      mask
    } = maskOptions;

    if (!character || position >= mask.length) {
      return false;
    }

    if (!isPositionEditable(position)) {
      return mask[position] === character;
    }

    const charRule = mask[position];
    return new RegExp(charRule).test(character);
  }

  function isPositionEditable(position) {
    const {
      mask,
      permanents
    } = maskOptions;
    return position < mask.length && permanents.indexOf(position) === -1;
  }
};

function getInputSelection(input) {
  return {
    start: input.selectionStart,
    end: input.selectionEnd,
    value: input.value
  };
}

function setInput(input, value, position) {
  input.value = value;
  input.setSelectionRange(position, position);
}

function buildInsertObject(direction, posStart, posEnd, value) {
  return {
    [direction]: {
      posEnd,
      posStart,
      value
    }
  };
}

function getInsertInfo(prev, cur) {
  if (prev.end > prev.start) {
    if (prev.start < cur.start) {
      const value = cur.value.slice(prev.start, cur.start);
      return Object.assign(Object.assign({}, buildInsertObject('remove', prev.start, prev.end)), buildInsertObject('add', prev.start, cur.start, value));
    }

    return buildInsertObject('remove', prev.start, prev.end);
  } else if (prev.start === prev.end && prev.start > cur.start) {
    return buildInsertObject('remove', cur.start, prev.start);
  } else if (prev.start < cur.start) {
    const value = cur.value.slice(prev.start, cur.start);
    return buildInsertObject('add', prev.start, cur.start, value);
  }

  return {};
}